import { enumValueNormalizer } from '../enum_value_normalizer';
export function selectOptionBuilder(value, label = null) {
    const text = label || enumValueNormalizer(value);
    return {
        text,
        value,
    };
}
export function selectOptionBooleanBuilder(value, label = null) {
    const text = label;
    return {
        text,
        value,
    };
}
